'use client'

import type { ReactNode } from 'react'

import { SelectableCard, Typography, VStack } from '@podo-app/design-system-temp'

export type ProductType = 'UNLIMITED' | 'LIGHT' | 'IPAD'

type Props = {
  icon: ReactNode
  title: string
  description: string
  selected: boolean
  badge?: string
  onClick: () => void
  'data-testid'?: string
}

const ProductTypeCard = ({ icon, title, description, selected, badge, onClick, 'data-testid': testId }: Props) => {
  return (
    <SelectableCard
      selected={selected}
      onClick={onClick}
      data-testid={testId}
      badge={
        badge ? (
          <div className="px-2 py-px h-5 text-[10px] font-semibold flex items-center text-white bg-[#FD6771] rounded-[4px_12px_0_4px]">
            {badge}
          </div>
        ) : undefined
      }
    >
      <div className="shrink-0 size-14 flex items-center justify-center">{icon}</div>
      <VStack className="gap-0.5 flex-1 items-start">
        <Typography size="body1" weight="semibold" className="text-gray-900">
          {title}
        </Typography>
        <span className="text-gray-500 text-[14px] font-normal leading-5 tracking-[-0.28px] text-left">
          {description}
        </span>
      </VStack>
    </SelectableCard>
  )
}

export default ProductTypeCard
